import React from 'react';
import Table, { HeaderRow, TableRow } from '../../common/Widgets/Table';
import { ButtonBack } from '../../common/Button/ButtonBack';
import { Link, useNavigate } from 'react-router-dom';
import { PageAbsolutePath } from '../../../consts/Common';
import Links from '../../common/Widgets/Links';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';

const CoverDetailsPage = (): JSX.Element => {
  const navigate = useNavigate();

  const goBack = (): void => {
    navigate(-1);
  };

  const insuranceTableHeader: HeaderRow = {
    columns: ['', 'Free Driveaway Insurance', 'Annual Insurance']
  };

  const insuranceTableRows: TableRow[] = [
    { columns: ['Level of cover', 'Comprehensive', 'Comprehensive'] },
    {
      columns: [
        'Length of cover',
        'Until 23:59 hours the day after the policy starts* *unless you have arranged extended cover with us',
        '1 year'
      ]
    },
    {
      columns: ['Age Limits', '21-79 years old', '17-90 years old']
    },
    {
      columns: [
        'Driver',
        'Policyholder plus one named driver',
        'Policyholder plus up to three named drivers'
      ]
    },
    {
      columns: [
        'Class of use',
        'Social, domestic, pleasure and commuting',
        'Social, domestic and pleasure, plus business use if required'
      ]
    },
    {
      columns: [
        'Minimum excess',
        '£500',
        'Minimum £150 - varies by insurer and may be higher on some vehicles. Please ask for details.'
      ]
    },
    {
      columns: [
        'Windscreen replacement excess',
        '£500',
        'Minimum £60 - varies by insurer and cover may be limited if our approved repairer is not used. Please ask for details.'
      ]
    },
    {
      columns: [
        'Windscreen repair excess',
        '£500',
        'Minimum £10 - varies by insurer and may be free. Cover may be limited if our approved repairer is not used. Please ask for details.'
      ]
    },
    {
      columns: [
        'Courtesy car during vehicle repair',
        '-',
        'Included (subject to availability)'
      ]
    },
    {
      columns: [
        'EU cover',
        'Comprehensive',
        'Comprehensive. The number of days may vary by insurer'
      ]
    },
    {
      columns: [
        'Personal accident',
        '£2000',
        'Minimum £2500 - limits vary by insurer. Please ask for details.'
      ]
    },
    {
      columns: [
        'Personal belongings',
        'Up to £100',
        'Minimum £100 - limits vary by insurer. Please ask for details.'
      ]
    },
    { columns: ['Child car seat replacement', '£100', 'Included'] },
    { columns: ['Legal expenses cover', '-', 'Available'] },
    {
      columns: [
        'Protected No Claims Discount cover',
        '-',
        'Available (providing you have a minimum of 4 years earned)'
      ]
    },
    { columns: ['Driving Other Cars', '-', 'Refer to your policy wording'] }
  ];

  const chevronLeftComponent = <FontAwesomeIcon icon={faChevronLeft} />;

  return (
    <div className='cover-details'>
      <Links
        id='back-link'
        title=''
        items={[{ to: '', text: 'Back', onClick: goBack }]}
        icon={chevronLeftComponent}
      />
      <h2>What are the differences in cover?</h2>
      <p>
        Free Driveaway Insurance and Annual Insurance both provide comprehensive
        cover. The main differences are:
      </p>
      <Table
        id='cover-details-table'
        header={insuranceTableHeader}
        rows={insuranceTableRows}
      />
      <p>
        <a
          id='lnkSeeMoreBenefits'
          className='in-text'
          href={PageAbsolutePath.Insurance.Landing}>
          {'> See more Annual Insurance benefits or get a quote'}
        </a>
      </p>
      <p>
        The offer of insurance is subject to eligibility and underwriting
        criteria. All cover is subject to the terms and conditions provided with
        the policy, the
        <Link
          id='lnkPolicyDocument'
          className='in-text'
          to={PageAbsolutePath.Insurance.PolicyDocuments}>
          Policy Document
        </Link>
        and the
        <Link
          id='lnkTermsOfBusiness'
          className='in-text'
          to={PageAbsolutePath.Insurance.BusinessTermsAncillaryPage}>
          Terms of Business
        </Link>
        .
      </p>
      <div className='flex-row'>
        <ButtonBack
          name='btnBack'
          text='Back'
          onClick={goBack}
          additionalClassNames='btn-back'
        />
      </div>
    </div>
  );
};

export default CoverDetailsPage;
